<template>
    <ul class="list-unstyled">
        <ComponentsTreeItem
            :item="hierarchy"
            @toggle="(item, isOpen) => $emit('toggle', item, isOpen)"
            @checked="checked"
            @unchecked="unchecked"
        >
            <template #title="data">
                <slot name="title" :item="data.item"/>
            </template>
        </ComponentsTreeItem>
    </ul>
</template>

<script>
import ComponentsTreeItem from "@/views/request/received/flow/components/concern-element/ComponentsTreeItem";
export default {
    components: {ComponentsTreeItem},
    props: {
        hierarchy: {
            type: Object,
            default() {
                return {
                    children: []
                };
            }
        }
    },
    methods: {
        checked(item) {
            this.$emit('checked', item);
        },
        unchecked(item) {
            this.$emit('unchecked', item);
        },
    }
}
</script>

<style lang="scss">
ul.product-hierarchy {
    padding-left: 1.5rem;
}
</style>
